export default function MetricCard({ label, value, sublabel, variant = 'default' }) {
  const variantStyles = {
    default: 'bg-surface',
    success: 'bg-success/10',
    alert: 'bg-alert/10',
    primary: 'bg-primary/10',
  };

  return (
    <div className={`rounded-xl border-2 border-ink shadow-brutal p-6 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-brutal-lg ${variantStyles[variant]}`}>
      <p className="text-sm font-semibold text-text-secondary uppercase tracking-wide">{label}</p>
      <p className="mt-2 text-3xl font-bold text-text-primary">{value}</p>
      {sublabel && <p className="mt-1 text-sm text-text-secondary">{sublabel}</p>}
    </div>
  );
}
